import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { managerActions } from '@store/reducers/manager/actions'
import type React from 'react'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import useIntervals from '@/hooks/useIntervals'
import { usePrintRender } from '../../hooks'
import { PageContent } from '../App/Modal/PageContent'
import css from './ModalContent.module.scss'
import { ProjectAvatar } from './ProjectAvatar'

export const ModalContent: React.FC = () => {
  const dispatch = useDispatch()

  const body = useRef(document.body)
  const { projectId, nodeId } = useParams<{
    projectId: string
    nodeId: string
  }>()

  const { isPrinting, isPdf, isThumbnail } = usePrintRender()

  useIntervals()

  const name = useSelector(migrationProjectSelector.getProjectTitle)

  useEffect(() => {
    if (projectId) {
      dispatch(managerActions.fetchProjectSaga({ id: projectId }))
    }
  }, [projectId])

  useEffect(() => {
    if (isPrinting) {
      body.current.classList.add('--print')

      if (isPdf) {
        body.current.classList.add('--pdf')
      }

      if (isThumbnail) {
        body.current.classList.add('--thumbnail')
      }
    }
  }, [])

  if (!nodeId) {
    return null
  }

  return (
    <div className={css.container} id="printed-node">
      <div className={css.header}>
        <div className={css.avatar}>
          <ProjectAvatar />
        </div>
        <span className={css.name}>{name}</span>
        <span
          className={css.link}
        >{`${window.location.host}/${projectId}`}</span>
      </div>
      <PageContent nodeId={nodeId} />
    </div>
  )
}
